import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../Table.css';
import DashboardLayout from '../Sidebar/DashboardLayout'; 
import ActionButtons from '../../commun/ActionButtons';
import ModalButton from '../../commun/ModalButton';
import FormInputMUI from '../../commun/FormInputMUI';
import TableFilterControls from '../../commun/TableFilterControls';
import useMessages from '../../../hooks/useMessages';
import { showDeleteConfirmation } from '../../commun/deletemsg';
import { generateRandomPassword } from '../../commun/generatepwd';
import { useNavigate } from 'react-router-dom';
import GenericTable from '../../commun/GenericTable';
import Pagination from '../../commun/Pagination';
import { Typography, Button, Checkbox, FormControlLabel, IconButton, TextField, InputAdornment, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import FormField from '../../Recruteur/candidat/AddTalent/FormField';
import CustomAlert from '../../commun/CustomAlert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { secteurOptions } from '../../commun/constants/options';
import { parseSecteursExcel } from '../../commun/autofillExcel';
import Chatbox from '../../commun/ChatBox';

const CompanyDashboard = () => {
  const [displayMode, setDisplayMode] = useState('card');
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const { messages, handleSuccess, handleError } = useMessages();
  const [showPassword, setShowPassword] = useState(false)
  const [page, setPage] = useState(1);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [companies, setCompanies] = useState([]);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [secteurOptions, setSecteurOptions] = useState([]);
  const userRole = localStorage.getItem('userType');

  const [formData, setFormData] = useState({
    lastName: '',
    firstName: '',
    email: '',
    phone: '',
    NomEntreprise: '',
    motDePasse: '',
    verificationCode: '',
  });

  const [editFormData, setEditFormData] = useState({
    id: null,
    NomEntreprise: '',
    sector: '',
    ice: '',
    email: '',
  });

  const columns = [
    {
      key: 'NomEntreprise',
      label: 'Nom de la société',
      render: (value, row) =>
        editingCompanyId === row._id ? (
          <input name="NomEntreprise" value={editFormData.NomEntreprise} onChange={handleEditFormChange} />
        ) : (
          value
        ),
    },

    {
  key: 'ice',
  label: 'SIRET / ICE',
  render: (value, row) =>
    editingCompanyId === row._id ? (
      <input name="ice" value={editFormData.ice} onChange={handleEditFormChange} />
    ) : (
      value
    ),
},
{
  key: 'utilisateurs',
  label: 'Nb utilisateurs',
  render: (value, row) => {
    const total = (row.utilisateursAdditionnels?.length || 0) + 1; // +1 pour le créateur
    return total;
  },
},
    {
      key: 'email',
      label: 'Email',
      render: (value, row) =>
        editingCompanyId === row._id ? (
          <input name="email" value={editFormData.email} onChange={handleEditFormChange} />
        ) : (
         <a href={`mailto:${row.utilisateur.email}`} className="link-action">{row.utilisateur.email}</a> 
        ),
    },
    {
      key: 'missions',
      label: 'Nombre de mission posté',
      render: (value, row) => row.missions || 0,
    },    
{
  key: 'entrepriseStatut',
  label: 'Statut Entreprise',
  render: (value, row) => (
    <div
      className={row.statut === 'active' ? 'statusActive' : 'statusInactive'}
      onClick={() => handleToggleEntrepriseStatus(row._id, row.statut)}
      style={{ cursor: 'pointer' }}
    >
      {row.statut === 'active' ? 'Active' : 'Inactive'}
    </div>
  ),
},

  ];

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) navigate('/');
    axios.get(`${API_BASE}/api/auth/entreprises`)
    .then(res => {
      const data = Array.isArray(res.data) ? res.data : [];
      setCompanies(data);
    })
      .catch(err => console.error('Erreur récupération entreprises :', err));
      parseSecteursExcel().then(setSecteurOptions).catch(console.error);

  }, [navigate, API_BASE]);

  const filteredCompanies = (companies || []).filter(company => {
    const utilisateur = company.utilisateur;
    if (!utilisateur) return false;
  
    const name = company.NomEntreprise || '';
    const matchesSearch = name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter ? utilisateur.statut === statusFilter : true;
    return matchesSearch && matchesStatus;
  });
  

  const paginatedData = filteredCompanies;

  const handleEdit = (id) => {
    const company = companies.find(c => c._id === id);
    setEditingCompanyId(id);
    setEditFormData({
      id: company.utilisateur?._id || '',
      NomEntreprise: company.NomEntreprise || '',
      sector: company.sector || '',
      ice: company.ice || '',
      email: company.utilisateur?.email || ''
    });    
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSaveEdit = async () => {
    try {
      const payload = {
        utilisateur: {
          id : editFormData.id,
          email: editFormData.email || ''
        },
        NomEntreprise: editFormData.NomEntreprise || '',
        sector: editFormData.sector || '',
        ice: editFormData.ice || ''
      };
      const response = await axios.patch(`${API_BASE}/api/entreprise/edit/${editFormData.id}`, payload);
  
      const updatedEntreprise = response.data;
  
      const updatedCompanies = companies.map((company) =>
        company._id === updatedEntreprise._id ? updatedEntreprise : company
      );  

  
      setCompanies(updatedCompanies);
      setEditingCompanyId(null);
    } catch (error) {
      setAlertMessage("Erreur lors de l'édition de l'entreprise :", error);
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };
  
  

  const handleCancelEdit = () => setEditingCompanyId(null);

const handleToggleEntrepriseStatus = async (entrepriseId, currentStatus) => {
  const updatedStatus = currentStatus === 'active' ? 'inactive' : 'active';

  try {
    await axios.patch(`${API_BASE}/api/entreprise/update-status/${entrepriseId}`, {
      statut: updatedStatus
    });

    const updatedCompanies = companies.map(c => {
      if (c._id === entrepriseId) {
        return {
          ...c,
          statut: updatedStatus
        };
      }
      return c;
    });

    setCompanies(updatedCompanies);
    setAlertMessage("Statut mis à jour avec succès");
    setAlertSeverity("success");
    setAlertOpen(true);
  } catch (error) {
    setAlertMessage("Erreur lors de la mise à jour du statut");
    setAlertSeverity("error");
    setAlertOpen(true);
  }
};

  
  const handleDelete = (id) => {
    showDeleteConfirmation({
      onConfirm: async () => {
        try {
          await axios.delete(`${API_BASE}/api/entreprise/delete/${id}`);
          setCompanies(companies.filter(c => c._id !== id));
        } catch (err) {
          const message =
          err.response?.data?.message || "Erreur inconnue lors de la suppression.";
          setAlertMessage(`Erreur : ${message}`);
          setAlertSeverity("error");
          setAlertOpen(true);
        }
      },
      onCancel: () =>{
        setAlertMessage("Suppression annulée");
        setAlertSeverity("error");
        setAlertOpen(true);
      },
    });
  };

  const handleGenerate = () => {
    const pwd = generateRandomPassword();
    setFormData(prev => ({ ...prev, motDePasse: pwd }));
  };

  const resetForm = () => {
    setFormData({
      lastName: '',
      firstName: '',
      email: '',
      phone: '',
      NomEntreprise: '',
      motDePasse: '',
      verificationCode: '',
    });
    setErrors({});
    handleSuccess('');
    handleError('');
  };

  const validateForm = () => {
    const newErrors = {};
    for (const [key, value] of Object.entries(formData)) {
      switch (key) {
        case 'NomEntreprise':
        case 'lastName':
        case 'firstName':
          if (!value.trim()) newErrors[key] = "Ce champ est requis.";
          break;
        case 'email':
          if (!value.trim()) newErrors.email = "Ce champ est requis.";
          else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) newErrors.email = "Email invalide.";
          break;
        case 'phone':
          if (!value.trim()) newErrors.phone = "Ce champ est requis.";
          else if (/^\+?[0-9]{12,}$/.test(value)) newErrors.phone = "Numéro de téléphone invalide.";
          break;
        case 'motDePasse':
          if (!value.trim()) newErrors.motDePasse = "Le mot de passe est requis.";
          else if (value.length < 8) newErrors.motDePasse = "Le mot de passe doit faire au moins 8 caractères.";
          break;
        default:
          break;
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return handleError("Veuillez remplir tous les champs obligatoires.");
    try {
      const response = await fetch(`${API_BASE}/api/auth/admin/add-entreprise`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, isAdminSignup: true }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Erreur inconnue");

      setAlertMessage("Inscription réussie ! Un email contenant votre mot de passe et vos coordonnées a été envoyé.");
      setAlertSeverity("success");
      setAlertOpen(true);
      const updatedData = await axios.get(`${API_BASE}/api/auth/entreprises`);
      setCompanies(updatedData.data);
      setTimeout(() => setShowModal(false), 2000);
      setTimeout(resetForm, 3000);
    } catch (error) {
      handleError(error?.response?.data?.message || error.message);
      setAlertMessage(error?.response?.data?.message || error.message);
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };

  return (
<section className="dashboardContainer" >
<div className="headerTalentWrapper">
        <h3 className="componentTitle">Les Entreprises</h3>
        <div className="top-controlsC">
        <TableFilterControls
          searchValue={searchTerm}
          onSearchChange={setSearchTerm}
          statusValue={statusFilter}
          onStatusChange={setStatusFilter}
        />
        <ModalButton onClick={() => setShowModal(true)} />

        </div>
        {showModal && (
          <div className="modal-overlay" onClick={() => { setShowModal(false); resetForm(); }}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h2>Formulaire d'ajout</h2>
              <form onSubmit={handleSubmit} className="application-form">
              <CustomAlert
                open={alertOpen}
                message={alertMessage}
                severity={alertSeverity}
                onClose={() => setAlertOpen(false)}
              />
                <FormInputMUI label="Nom de l'entreprise *" value={formData.NomEntreprise} onChange={(v) => handleInputChange("NomEntreprise", v)} error={errors.NomEntreprise} />
                <FormInputMUI label="Nom *" value={formData.lastName} onChange={(v) => handleInputChange("lastName", v)} error={errors.lastName} />
                <FormInputMUI label="Prénom *" value={formData.firstName} onChange={(v) => handleInputChange("firstName", v)} error={errors.firstName} />
                <FormInputMUI label="Email *" type="email" value={formData.email} onChange={(v) => handleInputChange("email", v)} error={errors.email} />
                <div className="phone-user">
                    <FormField
                    type="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                    error={errors.phone}
                  />
                </div>

                <div className="password-field-wrapper">
                <TextField
                  label="Mot de passe *"
                  type={showPassword ? 'text' : 'password'}
                  value={formData.motDePasse}
                  onChange={(e) => handleInputChange("motDePasse", e.target.value)}
                  error={!!errors.motDePasse}
                  helperText={errors.motDePasse}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  size="small"
                />
                <button
                  type="button"
                  className="generate-password-button"
                  onClick={handleGenerate}
                >
                  Générer
                </button>
              </div>


               <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
                           Confirmer
                         </Button>
              </form>
            </div>
          </div>
        )}
      </div>

      <GenericTable
        displayMode={displayMode}
        setDisplayMode={setDisplayMode}
        columns={columns}
        data={paginatedData}
        totalItems={companies.length }
        renderActions={(row) => (
          
        <IconButton
          onClick={() => navigate(`/admin/entreprises/${row._id}`)}
          color="primary"
          title="Voir les détails"
        >
          <VisibilityIcon />
        </IconButton>

        )}   
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}    
      />

      <Pagination page={page} setPage={setPage} totalItems={filteredCompanies.length} itemsPerPage={100} />
      {userRole !== 'agent' && <Chatbox userRole={userRole} />}
    </section>
  );
};

const Entreprises = () => (
  <DashboardLayout>
    <CompanyDashboard />
  </DashboardLayout>
);


export default Entreprises;
